import { connect } from 'react-redux'
import LogoLink from 'components/layout/LogoLink'

const mapStateToProps = state => ({
  pageId: state.layout.pageId,
  activePage: state.layout.controller
})

export default connect(mapStateToProps, null)(LogoLink)
